//-----------------------------
// save current campaign notes
//-----------------------------
export default function saveCurrentCampaignNotes(campaign_notes) {
  // -------------------------------
  // check got campaign notes array
  // -------------------------------
  if (!Array.isArray(campaign_notes)) return null
  //-----------------------------------------------------------------------------
  // create array with specified props (editable or keys) for each campaign note
  //-----------------------------------------------------------------------------
  const original_campaign_notes = campaign_notes.map((note) => ({
    id: note?.id ?? null, // character campaign note id if existing (should be there)
    note: note?.note ?? '',
    session_date: note?.session_date ?? '',
    updated_at: note?.updated_at ?? '',
  }))
  return original_campaign_notes
}
